import { useEffect, useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewCollectionsList } from "../../Redux/Actions/collectionsActions";
import { columnsCollections } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ListCollections = () => {
  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const [searchQuery, setSearchQuery] = useState("");

  const fetchDetails = (page, limit) => {
    const collectionData = {
      page,
      limit: limit,
      filter: searchQuery,
    };
    dispatch(viewCollectionsList(collectionData));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { collections, loading } = useSelector((state) => state.collections);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  // const filteredData =
  //   Array.isArray(collections?.data) &&
  //   collections.data.filter((collection) =>
  //     collection.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );

  useEffect(() => {
    if (collections?.total) {
      setPagination((prevData) => ({ ...prevData, total: collections.total }));
    }
  }, [collections]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setPagination((prevData) => ({ ...prevData, current: 1 }));
    fetchDetails(1, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Collections List"
      buttonhead2={canAdd ? "Add Collections" : null}
      navigateTo2={canAdd ? "/collections/add" : null}
      columns={columnsCollections(canEdit)}
      setState={setSearchQuery}
      filterFunction={filterHandler}
      dataSource={Array.isArray(collections?.data) ? collections.data : []}
      pagination={pagination}
      loading={loading}
      onChange={handleTableChange}
    ></TableComponent>
  );
};

export default ListCollections;
